<h4>Delete document</h4>
<p class="mb-5 text-grey-dark">
	Are you sure you would like to delete the following document?
</p>

<div class="flex p-3 border-gray-400 border-t border-b">
	<app-icon icon="file" class="mr-3"></app-icon>
	<p>{{ document.title }}</p>
</div>

<p class="text-grey-dark mt-3">
	This is a permanent action and cannot be undone.
</p>

<div class="flex justify-between mt-10">
	<app-button size="small" btn="tertiary" class="mr-5" (click)="cancelModal()"
		>Cancel</app-button
	>
	<app-button size="small" btn="error" (click)="deleteDocument()"
		>Delete</app-button
	>
</div>
